import { render, staticRenderFns } from "./UserValidSettingChangeActivationType.vue?vue&type=template&id=32abedf6&"
import script from "./UserValidSettingChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserValidSettingChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports